import { Modal } from 'antd';

interface Props {
    loadingConfirm?: boolean,
    visibleModal?: boolean,
    handleAcceptModal?: any,
    handleCloseModal?: any,
    okText?: string,
    cancelText?: string,
    title?: string,
    btnDisable?: boolean,
    content?: any,
    none?: any,
    width?: number
}
export default function TruckingModal(props: Props) {

    const { loadingConfirm, visibleModal,
        title, handleCloseModal, handleAcceptModal, content, width = 400 } = props;
    return (
        <div>
            <Modal
                confirmLoading={loadingConfirm}
                width={width}
                title={title}
                centered
                visible={visibleModal}
                onCancel={handleCloseModal}
                onOk={handleAcceptModal}
                footer={null}
            >
                {content}

            </Modal>
        </div>
    )



}
